const BillingDashboard = () => import('./BillingDashboard.vue')

export default [
  {
    name: 'billing',
    path: 'billing',
    component: BillingDashboard,
    meta: {
      access: ['org.settings.manage', 'org.billing.view']
    }
  }
]
